const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Kaleb Pattawi</h4>
            <p>Engineer, athlete, and lifelong learner. Writing about fitness, work, travel, and learning as I go.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><button onClick={() => scrollToSection('newsletter')} className="footer-link">Newsletter</button></li>
              <li><button onClick={() => scrollToSection('about')} className="footer-link">About</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button></li>
              <li><button onClick={() => scrollToSection('blog')} className="footer-link">Archive</button></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Brainwaves Newsletter</h4>
            <p>Weekly-ish notes on what I'm thinking, testing, or learning.</p>
            <button onClick={() => scrollToSection('newsletter')} className="newsletter-link">Subscribe</button>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Kaleb Pattawi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
